import { useCallback, useState } from 'react';
import { IModalWindowProps } from '@cian/ui-kit';

export const useModalWindow = (initialProps?: Partial<IModalWindowProps>) => {
  const [open, setOpen] = useState(false);

  const onClose = useCallback(() => {
    setOpen(false);
  }, []);

  const [modalProps, setModalProps] = useState<Partial<IModalWindowProps>>({
    fixed: true,
    width: 960,
    size: 'M',
    ...initialProps,
  });

  const openModal = useCallback(
    (props: Partial<IModalWindowProps>) => {
      setOpen(true);
      setModalProps({
        ...modalProps,
        ...props,
      });
    },
    [modalProps],
  );

  return {
    openModal,
    modalProps: {
      open,
      onClose,
      ...modalProps,
    },
  };
};
